import React from 'react';
import { useTranslation } from "react-i18next";

import * as Icons from "assets/icons";
import { useAll as useOrganizations } from "modules/organization/hooks";

import * as Grid from "components/Grid";
import Select from "components/Select";
import Button from "components/Button";
import Label from 'components/Label';

const FilterList = ({ params, setParams, setSearch }) => {
  const { t, i18n } = useTranslation();
  const organization = useOrganizations();

  const handleSearch = (values) => {
    setParams({
      name: values,
    });
  }

  return (
    <Grid.Row gutter={20} align="bottom">
      <Grid.Col xs={12}>
        <Label title={t("column_organization")}>
          <Select
            mode="multiple"
            showSearch
            options={organization.items.map(item => ({
              label: item.name[i18n.language],
              value: item.name[i18n.language]
            }))}
            value={params.name || []}
            onChange={handleSearch}
            placeholder={t('column_organization')}
            disabled={!organization.isFetched}
          />
        </Label>
      </Grid.Col>

      <Grid.Col xs={2}>
        <Button
          background='blue'
          color='white'
          border='blue'
          radius='sm'
          onClick={() => setSearch(prev => prev + 1)}
        >
          <Icons.Search /> {t('find')}
        </Button>
      </Grid.Col>
    </Grid.Row>
  );
};

export default FilterList;